export default __webpack_public_path__ + "static/media/3.f982e91b.png";